import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Order } from "../../types/api/Order";

interface AddShipping {
  id: string | null;
  carrier: string;
  tracking_number: string;
  status: string;
}

export default (orgId: string, orderId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Order, null, AddShipping>(
    `shipping_${orderId}`,
    async (body: AddShipping) =>
      Put(
        `/api/order/${orderId}/shipping`,
        await getAccessTokenSilently(),
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`admin_orders_${orgId}`]);
      },
    }
  );
};
